<div class="dsn-textarea-container">
    <textarea
        class="dsn-textarea"
        [class.dsn-textarea--invalid]="isInvalid"
        [class.dsn-textarea--disabled]="disabled"
        [class.dsn-textarea--has-value]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [rows]="rows"
        [cols]="cols"
        [(ngModel)]="value"
    ></textarea>
    <span *ngIf="isInvalid" class="dsn-textarea__invalid-message">
        {{ invalidMessage }}
    </span>
</div>
